import Swiper from 'swiper';
import {Navigation, FreeMode, Mousewheel} from 'swiper/modules';
import 'swiper/swiper-bundle.css';


const initSliders = () => {

  document.querySelectorAll('[data-slider]').forEach(slider => {

      if (slider.hasAttribute('data-initialized')) {
        // Refresh layout in case the slider was previously mounted with zero
        // dimensions (e.g. inside a collapsed accordion).
        slider.swiper?.update();
        return;
      }
      slider.setAttribute('data-initialized', 'true');

      const options = {
        modules: [FreeMode, Mousewheel],
        loop: false,
        autoHeight: false,
        allowTouchMove: true,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 6,
        },
        navigation: {
        },
        spacesBetween: 0,
        slidesPerView: 'auto',
        breakpoints: {

        }
      }

      const swiper = new Swiper(slider.querySelector('.swiper'), options);
      slider.swiper = swiper;
    }
  )
}

initSliders()
window.addEventListener('init:sliders', initSliders)
